/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-18 07:22:40
 * Modified By: Val Liu
 * -----
 */

import { StringHelper } from "../utilities";
import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "./core";
import { lang } from "@root/core/i18n";

// @uiMultiple - attach the `multiple` prop the form element or table cell.

@UITag.set({ default: true })
export class uiMultiple extends BaseUITag {
    appliedTo: EUITagTarget[] = [
        EUITagTarget.TableBodyCell,
        EUITagTarget.FormElement,
        EUITagTarget.FormSubmit,
    ];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean];
    allowNullRule: boolean = true; /// default: true

    /// set props :description
    parse(input: IUITagInput): IUITagResult | null {
        let rule = this.parseRule(input);

        if (input.isDefault === true) {
            /// default from metadata type
            rule = input.meta.attr.type.isArray;
        } else if (rule == null) {
            rule = true;
        }

        /// normal case
        return {
            props: { multiple: rule },
        };
    }
}
